import { createApp } from 'vue'
import { createPinia } from 'pinia'
import VueMatomo from 'vue-matomo'
import App from './App.vue'
import { router } from './router'
import { i18n } from './i18n'
import './assets/main.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(VueMatomo, {
  host: 'https://matomo.matumi.anthill.hk',
  siteId: 7,
  router,
})

app.mount('#app')
